module.exports = __webpack_public_path__ + "img/connect-ide.3f8c3e42.svg";